import { render, staticRenderFns } from "./availability.vue?vue&type=template&id=2077f0ae&scoped=true&"
import script from "./availability.vue?vue&type=script&lang=js&"
export * from "./availability.vue?vue&type=script&lang=js&"
import style0 from "./availability.vue?vue&type=style&index=0&id=2077f0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2077f0ae",
  null
  
)

component.options.__file = "availability.vue"
export default component.exports